import React from "react";
import { Route, Routes } from "react-router-dom";
import Home from "./containers/home/Home";
import PropertySearch from "./containers/property/PropertySearch";
import LeaseSearch from "./containers/property/LeaseSearch";
import OwnerPageSearch from "./containers/owner/page/OwnerPageSearch";
import OwnerPageDetail from "./containers/owner/page/OwnerPageDetail";
import EntityPageSearch from "./containers/entity/page/EntityPageSearch";
import CityscopeList from "./containers/lookups/CityscopeList";
import ScheduleList from "./containers/lookups/ScheduleList";
import ArticleCategoryList from "./containers/lookups/ArticleCategoryList";
import MergerSubsList from "./containers/mergersubs/MergerSubsList";
import MergerSubsExport from "./containers/mergersubs/MergerSubsListExport";
import UserList from "./containers/lookups/UserList";
import AuSuburbList from "./containers/lookups/AuSuburbList";
import WalkCopyList from "./containers/walkcopy/WalkCopyList";
import SalutationList from "./containers/lookups/SalutationList";
import PositionList from "./containers/lookups/PositionList";
import HeadOfficePageSearch from "./containers/headoffice/page/HeadOfficePageSearch";
import PropertyDetail from "./containers/property/PropertyDetail";
import SaleSheetDetail from "./containers/salesheet/SaleSheetDetail";
import OwnerDetail from "./containers/owner/OwnerDetail";
import ProposalDetail from "./containers/proposal/ProposalDetail";
import ArticleDetail from "./containers/article/ArticleDetail";
import LeaseDetail from "./containers/property/LeaseDetail";
import SaleDetail from "./containers/sale/SaleDetail";
import EntityPageDetail from "./containers/entity/page/EntityPageDetail";
import HeadOfficePageDetail from "./containers/headoffice/page/HeadOfficePageDetail";
import QueryDetail from "./containers/property/QueryDetail";
import TextPreview from "./containers/property/TextPreview";
import OtherProofing from "./containers/proofing/OtherProofing";
import WithholdingProofing from "./containers/proofing/WithholdingProofing";
import HybridProofingDetail from "./containers/proofing/HybridProofingDetail";
import SaleSheetFollowUpQueue from "./containers/queues/SaleSheetFollowUpQueue";
import SaleSheetFollowUpDetailQueue from "./containers/queues/SaleSheetFollowUpDetailQueue";
import AsicSearchQueue from "./containers/queues/AsicSearchQueue";
import QueriesQueue from "./containers/queues/QueriesQueue";
import NotFound from "./containers/common/NotFound";
import CountryList from "containers/lookups/CountryList";
import NzSuburbList from "containers/lookups/NzSuburbList";
import CPIRatesList from "containers/lookups/CPIRatesList";
import SalesFeedQueue from "./containers/queues/SalesFeedQueue";
import IntroPgXDetail from "./containers/intropgx/IntroPgXDetail";
import SLMAddressSearch from "./containers/slm/address/SLMAddressSearch";
import SLMAddressDetail from "./containers/slm/address/SLMAddressDetail";
import SLMLeaseSearch from "./containers/slm/lease/SLMLeaseSearch";
import SLMLeaseDetail from "./containers/slm/lease/SLMLeaseDetail";
import SLMEntityDetail from "./containers/slm/lease/SLMEntityDetail";
import SLMOwnerDetail from "./containers/slm/shared/SLMOwnerDetail";
import SLMCategoriesList from "./containers/slm/lookups/SLMCategoriesList";
import SLMSuburbList from "./containers/slm/lookups/SLMSuburbList";
import SLMRCASuppressionList from "./containers/slm/lookups/SLMRCASuppressionList";
import SLMRCAKeywordSuppressionList from "./containers/slm/iscompanykeywords";
import SLMSaleSearch from "./containers/slm/sale/SLMSaleSearch";
import SLMSaleDetail from "./containers/slm/sale/SLMSaleDetail";
// import CoapiDemo from "containers/coapidemo/CoapiDemo";


const AppRoutes = ({ childProps }) => {
    return (
        <Routes>
            <Route path="/" element={<Home {...childProps} />} />
            <Route path="/properties" element={<PropertySearch {...childProps} />} />
            <Route path="/properties/:id" element={<PropertyDetail {...childProps} />} />
            <Route path="/cityscopes" element={<CityscopeList {...childProps} />} />
            <Route path="/articlecategories" element={<ArticleCategoryList {...childProps} />} />
            <Route path="/users" element={<UserList {...childProps} />} />
            <Route path="/ausuburbs" element={<AuSuburbList {...childProps} />} />
            <Route path="/nzsuburbs" element={<NzSuburbList {...childProps} />} />
            <Route path="/countries" element={<CountryList {...childProps} />} />
            <Route path="/cpirates" element={<CPIRatesList {...childProps} />} />
            <Route path="/salutations" element={<SalutationList {...childProps} />} />
            <Route path="/positions" element={<PositionList {...childProps} />} />
            <Route path="/walkcopy" element={<WalkCopyList {...childProps} />} />
            <Route path="/intropgx" element={<IntroPgXDetail {...childProps} />} />
            <Route path="/mergersubs" element={<MergerSubsList {...childProps} />} />
            <Route path="/mergersubsexport" element={<MergerSubsExport {...childProps} />} />
            <Route path="/schedules/:cityscope" element={<ScheduleList {...childProps} />} />
            <Route path="/queues/salesheets" element={<SaleSheetFollowUpQueue {...childProps} />} />
            <Route path="/queues/salesheets/:id" element={<SaleSheetFollowUpDetailQueue {...childProps} />} />
            <Route path="/queues/asicsearches" element={<AsicSearchQueue {...childProps} />} />
            <Route path="/queues/queries" element={<QueriesQueue {...childProps} />} />
            <Route path="/queues/salesfeed" element={<SalesFeedQueue {...childProps} />} />
            <Route path="/owners" element={<OwnerPageSearch {...childProps} />} />
            <Route path="/entities" element={<EntityPageSearch {...childProps} />} />
            <Route path="/headoffices" element={<HeadOfficePageSearch {...childProps} />} />
            <Route path="/leases" element={<LeaseSearch {...childProps} />} />
            <Route path="/proofing/WithholdingProofing" element={<WithholdingProofing {...childProps} />} />
            <Route path="/proofing" element={<OtherProofing {...childProps} />} />
            <Route path="/proofing/ad-hoc" element={<HybridProofingDetail {...childProps} />} />
            <Route path="/iscompanykeywords" element={<SLMRCAKeywordSuppressionList {...childProps} />} />
            <Route path="/proposals/:id" element={<ProposalDetail {...childProps} />} />
            <Route path="/properties/:propertyid/proposals/:id" element={<ProposalDetail {...childProps} />} />
            <Route path="/entities/:id" element={<EntityPageDetail {...childProps} />} />
            <Route path="/headoffices/:id" element={<HeadOfficePageDetail {...childProps} />} />
            <Route path="/owners/:id" element={<OwnerPageDetail {...childProps} />} />
            <Route path="/properties/:id" element={<PropertyDetail {...childProps} />} />
            <Route path="/properties/new" element={<PropertyDetail {...childProps} />} />
            <Route path="/properties/:propertyid/owners/:id" element={<OwnerDetail {...childProps} />} />
            <Route path="/properties/:propertyid/leases/:id" element={<LeaseDetail {...childProps} />} />
            <Route path="/properties/:propertyid/queries/:id" element={<QueryDetail {...childProps} />} />
            <Route path="/properties/:propertyid/previewtext" element={<TextPreview {...childProps} />} />
            <Route path="/properties/:propertyid/articles/:id" element={<ArticleDetail {...childProps} />} />
            <Route path="/properties/:propertyid/sales/:id" element={<SaleDetail {...childProps} />} />
            <Route path="/properties/:propertyid/salesheets/:id" element={<SaleSheetDetail {...childProps} />} />
            <Route path="/articles/:id" element={<ArticleDetail {...childProps} />} />
            <Route path="/sales/:id" element={<SaleDetail {...childProps} />} />
            <Route path="/proofing/WithholdingProofing" element={<WithholdingProofing {...childProps} />} />
            <Route path="/proofing/ad-hoc" element={<HybridProofingDetail {...childProps} />} />
            <Route path="/salesheets/:id" element={<SaleSheetDetail {...childProps} />} />
            <Route path="/signin" element={<PropertySearch {...childProps} />} />

            {/* SLM Screens */}
            <Route path="/slmaddresses" element={<SLMAddressSearch {...childProps} />} />
            <Route path="/slmaddresses/:id" element={<SLMAddressDetail {...childProps} />} />
            <Route path="/slmleases" element={<SLMLeaseSearch {...childProps} />} />
            <Route path="/slmleases/:id" element={<SLMLeaseDetail {...childProps} />} />
            <Route path="/slmentities/:id" element={<SLMEntityDetail {...childProps} />} />
            <Route path="/slmowners/new" element={<SLMOwnerDetail {...childProps} />} />
            <Route path="/slmowners/:id" element={<SLMOwnerDetail {...childProps} />} />
            <Route path="/slmsales" element={<SLMSaleSearch {...childProps} />} />
            <Route path="/slmsales/:id" element={<SLMSaleDetail {...childProps} />} />
            <Route path="/slmcategories" element={<SLMCategoriesList {...childProps} />} />
            <Route path="/slmsuburbs" element={<SLMSuburbList {...childProps} />} />
            <Route path="/slmrcasuppressionlist" element={<SLMRCASuppressionList {...childProps} />} />
            {/* SLM iscompanykeywords uses the same class as Cityscope iscompanykeywords */}

            {/*
        <AppliedRoute path="/slmagency/:id" element={<AppliedRoute component={SLMAgencyDetail} {...childProps} />} />

        <Route path="/coapidemo" element={<AppliedRoute component={CoapiDemo} {...childProps} />} />

        { /* Finally, catch all unmatched routes */}
            <Route path="*" element={<NotFound />} />
        </Routes>);
};
export default AppRoutes;